var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-482 -95)"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0 0H8.953V8.953H0zM11.047 0L20 0 20 8.953 11.047 8.953zM0 11.047L8.953 11.047 8.953 20 0 20zM11.047 11.047L20 11.047 20 20 11.047 20z",
      "transform": "translate(484 97)"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }